import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import useMailComprobante from '../hooks/useMailComprobante';
import { MailComprobanteCampos, MailComprobanteAcciones } from '../MailComprobanteForm/MailComprobanteForm';
import { nombreComprobante } from '../textosComprobante';

/** Envío del PDF de un comprobante por mail (ver useMailComprobante). */
const ImpresionMailModal = ({ comprobante, onClose }) => {
  const mail = useMailComprobante(comprobante, onClose);
  // En celular el modal ocupa toda la pantalla.
  const pantallaCompleta = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  return (
    <Dialog open={!!comprobante} onClose={mail.enviando ? undefined : onClose} fullWidth fullScreen={pantallaCompleta} maxWidth="sm">
      <DialogTitle>{comprobante ? `Enviar por mail ${nombreComprobante(comprobante)}` : ''}</DialogTitle>
      <DialogContent dividers>
        <MailComprobanteCampos mail={mail} />
      </DialogContent>
      <DialogActions>
        <MailComprobanteAcciones mail={mail} onCancelar={onClose} />
      </DialogActions>
    </Dialog>
  );
};

export default ImpresionMailModal;
